var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./CulturalResourceSelectionUndertaking.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-f715113a\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./CulturalResourceSelectionUndertaking.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/CulturalResourceSelectionUndertaking.vue
// module id = 848
// module chunks = 1